import React, {useState} from 'react';
import {Button, CardBody, Col, Form, FormGroup, Input, Table} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {student_strings} from "../../translations/student_translations";
import Row from "reactstrap/es/Row";
import RuleTableRow from "../Tables/RuleTableRow";
import {resource_strings} from "../../translations/resource_translations";
import dateHelpers from "../../helpers/DateHelper";
import resourceHelper from "../../helpers/ResourceHelper";
import Select from "react-select";
import ResourceApiService from "../../api/resource-api-service";

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);

const RulesOverview = (props) => {
    const [search_in_progress, setSearchState] = useState(false);
    const [show_loader, setShowLoader] = useState(false);
    const [rule, setRule] = useState(resourceHelper.emptyRule());
    const [rules, setRules] = useState(props.rules);
    const [showRule, setShowRule] = useState(false);
    const [days, setDays] = useState("");
    const [weeks, setWeeks] = useState("");
    const [selectedTeacher, setselectedTeacher] = useState(null);
    const [selectedRoom, setselectedRoom] = useState(null);
    const [isOnline, setIsOnline] = useState(rule ? rule.is_online : false);
    const [link, setLink] = useState(rule ? rule.link : "");

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    function getClassType() {
        ResourceApiService.classType(props.classTypeId)
            .then(res => {
                setRules(res.rules);
                props.updateClassType(res)
            })
            .catch(function (error) {
                console.log(error.toJSON());
            });
    };

    const deleteRule = (e, rule) => {
        e.preventDefault();

        ResourceApiService.deleteRule(props.classTypeId, rule.id)
            .then(res => {
                getClassType();
            })
            .catch(function (error) {
                console.log(error.toJSON());
            });
    };

    const editRule = (e, rule) => {
        e.preventDefault();

        setRule(rule);
        setLink(rule.link);
        setIsOnline(rule.is_online);

        setShowRule(true)
    };

    const renderTableData = () => {
        const rulesSorted = rules.sort((a, b) => dateHelpers.stringTimeToDate(a.time) - dateHelpers.stringTimeToDate(b.time));
        return rulesSorted
            .map((rule, index) => {
                return (
                    <RuleTableRow rule={rule} key={rule.id} deleteRule={deleteRule} editRule={editRule}
                    />
                )
            })
    };

    localize();

    const handleChange = (event) => {
        const r = rule;
        r.time = event.target.value;

        setRule(r);
    };

    const handleIsOnlineChange = (event) => {
        const r = rule;
        r.is_online = event.target.checked;
        setIsOnline(event.target.checked);

        setRule(r);
    };

    function getTeacher() {
        return rule.teachers && rule.teachers.length > 0 ? {
            value: rule.teachers[0].id,
            label: rule.teachers[0].name
        } : ""
    }

    const handleTeacherSelected = selectedOption => {
        const t = props.teachers.find(it => it.id === selectedOption.value);
        const r = rule;
        r.teachers = [t];
        r.teacher_id = t.id;
        setselectedTeacher(t);

        setRule(r)
    };

    const teacherOptions = () => {
        if (props.teachers && props.teachers.length > 0) {
            const options = [];
            props.teachers.forEach(t => {
                    options.push({value: t.id, label: t.name})
                }
            );

            return options
        } else return [];
    };

    const getRoom = () => {
        if (rule.rooms && rule.rooms.length > 0) {
            return {value: rule.rooms[0].id, label: rule.rooms[0].name}
        } else return ""
    };

    const roomOptions = () => {
        if (props.rooms && props.rooms.length > 0) {
            const options = [];
            props.rooms.forEach(t => {
                    options.push({value: t.id, label: t.name})
                }
            );

            return options
        } else return [];
    };

    const handleLinkChanged = event => {
        setLink(event.target.value);
    };

    const handleRoomSelected = selectedOption => {
        const t = props.rooms.find(it => it.id === selectedOption.value);
        const r = rule;
        r.rooms = [t];
        r.room_id = t.id;
        setselectedRoom(t);

        setRule(r)
    };

    function handleDayChange(event, dayNumber) {
        let checkBoxValue = event.target.checked;
        const r = rule;
        const d = rule.days.split(",");

        if (d.includes(String(dayNumber))) {
            if (checkBoxValue === false) {
                const index = d.indexOf(String(dayNumber));
                if (index !== -1) d.splice(index, 1);
            }
        } else {
            if (checkBoxValue === true) {
                d.push(String(dayNumber))
            }
        }

        const res = d.sort().join(",").replace(/(^,)|(,$)/g, "");

        setDays(res);
        r.days = res;

        setRule(r)
    };

    const closeEditRuleView = e => {
        e.preventDefault();

        setShowRule(false);
        setRule(resourceHelper.emptyRule());
    };

    const startAddingRule = (e) => {
        e.preventDefault();

        setShowRule(true);
    };

    function updateRule(e) {
        e.preventDefault();

        const r = {
            id: rule.id,
            time: rule.time,
            days: rule.days,
            regularity: rule.regularity,
            link: link,
            is_online: isOnline
        };

        if (rule.teacher_id) {
            r.teacher_id = rule.teacher_id;
        }

        if (rule.room_id) {
            r.room_id = rule.room_id;
        }

        if (r.id) {
            ResourceApiService.updateRule(props.classTypeId, r)
                .then(res => {
                    setRules(res.rules);
                    props.updateClassType(res)
                    setShowRule(false);
                })
                .catch(function (error) {
                    console.log(error.toJSON());
                });
        } else {
            ResourceApiService.postRule(props.classTypeId, r)
                .then(res => {
                    setRules(res.rules);
                    props.updateClassType(res);
                    setShowRule(false);
                })
                .catch(function (error) {
                    console.log(error.toJSON());
                });
        }
    }

    function handleWeekChange(e, value) {

        const r = rule;
        r.regularity = value;

        setWeeks(value);
        setRule(r);
    }

    const isEveryWeek = () => {
        return rule.regularity === "1,2,3,4" || rule.regularity === "0,1,2,3,4,5,6"
    };

    const isEvenWeeks = () => {
        return rule.regularity === "2,4" || rule.regularity === "0,2,4,6"
    };

    function isOddWeeks() {
        return rule.regularity === "1,3" || rule.regularity === "1,3,5"
    };

    return (
        <>
            <FormGroup className="mb-0 mt--3 text-center">
                {!showRule &&
                <Button
                    color="warning"
                    onClick={e => startAddingRule(e)}
                    size="lg"
                >
                    {resourceStrings.add_rule}
                </Button>
                }
            </FormGroup>

            {/*Edit rule*/}

            {showRule &&
            <CardBody>
                {/*{rule.teacher_id} {rule.room_id}*/}
                <Form>
                    <div className="pl-lg-4">
                        <Row>
                            <Col lg="6">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-start"
                                    >
                                        <i className="ni ni-watch-time mr-1"/>
                                        {resourceStrings.starts_at}
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        onChange={handleChange}
                                        defaultValue={rule.time}
                                        id="input-start"
                                        type="time"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="12">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                    >
                                        {resourceStrings.teacher}
                                    </label>
                                    <Row>
                                        <Col lg="12">
                                            <Select
                                                style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)'
                                                }}
                                                className="form-control-alternative"
                                                placeholder={commonStrings.select}
                                                value={getTeacher()}
                                                defaulValue={getTeacher()}
                                                onChange={handleTeacherSelected}
                                                options={teacherOptions()}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg="12">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                    >
                                        {resourceStrings.room}
                                    </label>
                                    <Row>
                                        <Col lg="12">
                                            <Select
                                                style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)'
                                                }}
                                                placeholder={commonStrings.select}
                                                className="form-control-alternative"
                                                value={getRoom()}
                                                onChange={handleRoomSelected}
                                                options={roomOptions()}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg="12">
                                <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                    <input
                                        className="custom-control-input"
                                        id="input-online-cb"
                                        onChange={e => handleIsOnlineChange(e)}
                                        checked={rule.is_online}
                                        type="checkbox"
                                    />
                                    <label className="custom-control-label" htmlFor="input-online-cb">
                                        {resourceStrings.online_class}
                                    </label>
                                    <div>
                                        <i> <small>{resourceStrings.online_class_expl}</small> </i>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {isOnline &&
                        <Row>
                            <Col lg="12">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-link"
                                    >
                                        {resourceStrings.online_link}
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-link"
                                        placeholder={resourceStrings.online_link_placeholder}
                                        onChange={e => handleLinkChanged(e)}
                                        value={link}
                                        rows="3"
                                        type="textarea"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        }

                        <Row>
                            <Col lg="6">
                                <Row>
                                    <Col lg="12">
                                        <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                            <input
                                                className="custom-control-input"
                                                id="input-day-cb-0"
                                                onChange={e => handleDayChange(e, 0)}
                                                checked={rule.days && rule.days.includes('0')}
                                                type="checkbox"
                                            />
                                            <label className="custom-control-label" htmlFor="input-day-cb-0">
                                                {commonStrings.short_day.mon}
                                            </label>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg="12">
                                        <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                            <input
                                                className="custom-control-input"
                                                id="input-day-cb-1"
                                                onChange={e => handleDayChange(e, 1)}
                                                checked={rule.days && rule.days.includes('1')}
                                                type="checkbox"
                                            />
                                            <label className="custom-control-label" htmlFor="input-day-cb-1">
                                                {commonStrings.short_day.tue}
                                            </label>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg="12">
                                        <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                            <input
                                                className="custom-control-input"
                                                id="input-day-cb-2"
                                                onChange={e => handleDayChange(e, 2)}
                                                checked={rule.days && rule.days.includes('2')}
                                                type="checkbox"
                                            />
                                            <label className="custom-control-label" htmlFor="input-day-cb-2">
                                                {commonStrings.short_day.wed}
                                            </label>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg="12">
                                        <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                            <input
                                                className="custom-control-input"
                                                id="input-day-cb-3"
                                                onChange={e => handleDayChange(e, 3)}
                                                checked={rule.days && rule.days.includes('3')}
                                                type="checkbox"
                                            />
                                            <label className="custom-control-label" htmlFor="input-day-cb-3">
                                                {commonStrings.short_day.thu}
                                            </label>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg="12">
                                        <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                            <input
                                                className="custom-control-input"
                                                id="input-day-cb-4"
                                                onChange={e => handleDayChange(e, 4)}
                                                checked={rule.days && rule.days.includes('4')}
                                                type="checkbox"
                                            />
                                            <label className="custom-control-label" htmlFor="input-day-cb-4">
                                                {commonStrings.short_day.fri}
                                            </label>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg="12">
                                        <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                            <input
                                                className="custom-control-input"
                                                id="input-day-cb-5"
                                                onChange={e => handleDayChange(e, 5)}
                                                checked={rule.days && rule.days.includes('5')}
                                                type="checkbox"
                                            />
                                            <label className="custom-control-label" htmlFor="input-day-cb-5">
                                                {commonStrings.short_day.sat}
                                            </label>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg="12">
                                        <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                            <input
                                                className="custom-control-input"
                                                id="input-day-cb-6"
                                                onChange={e => handleDayChange(e, 6)}
                                                checked={rule.days && rule.days.includes('6')}
                                                type="checkbox"
                                            />
                                            <label className="custom-control-label" htmlFor="input-day-cb-6">
                                                {commonStrings.short_day.sun}
                                            </label>
                                        </div>
                                    </Col>
                                </Row>


                            </Col>

                            <Col lg="6">
                                <Row>
                                    <Col lg="12">
                                        <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                            <input
                                                className="custom-control-input"
                                                id="input-ew-cb"
                                                onChange={e => handleWeekChange(e, "1,2,3,4")}
                                                checked={isEveryWeek()}
                                                type="checkbox"
                                            />
                                            <label className="custom-control-label" htmlFor="input-ew-cb">
                                                {commonStrings.every_week}
                                            </label>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg="12">
                                        <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                            <input
                                                className="custom-control-input"
                                                id="input-ow-cb"
                                                onChange={e => handleWeekChange(e, "1,3")}
                                                checked={isOddWeeks()}
                                                type="checkbox"
                                            />
                                            <label className="custom-control-label" htmlFor="input-ow-cb">
                                                {commonStrings.odd_weeks}
                                            </label>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg="12">
                                        <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                            <input
                                                className="custom-control-input"
                                                id="input-evw-cb"
                                                onChange={e => handleWeekChange(e, "2,4")}
                                                checked={isEvenWeeks()}
                                                type="checkbox"
                                            />
                                            <label className="custom-control-label" htmlFor="input-evw-cb">
                                                {commonStrings.even_weeks}
                                            </label>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                    </div>


                    {(rule.days === "" || rule.regularity === "") &&
                    <div className="text-center">
                        <label style={{color: "red"}}>
                            {resourceStrings.rule_restrictions}
                        </label>
                    </div>
                    }

                    <Row>
                        <Col lg="12">
                            <Col className="text-right">
                                <Button
                                    color="warning"
                                    outline="button"
                                    size="lg"
                                    onClick={e => closeEditRuleView(e)}
                                >
                                    {commonStrings.close}
                                </Button>

                                <Button
                                    color="default"
                                    size="lg"
                                    disabled={(rule.days === "" || rule.regularity === "")}
                                    onClick={e => updateRule(e)}
                                >
                                    {commonStrings.save}
                                </Button>
                            </Col>
                        </Col>
                    </Row>

                </Form>
            </CardBody>
            }

            {/*Existing rules*/}
            {!showRule &&
            <Row>
                <Col xl="12">

                    <Table
                        className="align-items-center table-dark table-flush mt-2"
                        responsive
                    >
                        <thead className="thead-dark">
                        <tr>
                            <th scope="col">Rules</th>
                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        {renderTableData()}
                        </tbody>
                    </Table>
                </Col>
            </Row>
            }
        </>
    );
};

export default RulesOverview;